import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
// import { computed, autorun, observable, action, reaction } from 'mobx';
import { computed, autorun, observable, action } from 'mobx';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';
import { INFO_EVENT } from 'shared/dictionaries/events';

import Typography from 'material-ui/Typography';
import ExpansionPanel, {
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  ExpansionPanelActions
} from 'material-ui/ExpansionPanel';
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from 'material-ui/Table';
import Button from 'material-ui/Button';
import { ChevronDown } from 'mdi-material-ui';
import withAppStore from 'decorators/withAppStore';

import styles from 'styles/components/CodeInfoSection';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoSection extends Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    expanded: PropTypes.bool,
    noPadding: PropTypes.bool,
    list: PropTypes.array,
    table: PropTypes.shape({
      headers: PropTypes.array,
      rows: PropTypes.array.isRequired,
    }),
    sourceLink: PropTypes.string,
    staticText: PropTypes.string,
    action: PropTypes.string,
    count: PropTypes.number,

  }

  static defaultProps = {
    title_summary: '',
    expanded: true,
    noPadding: false
  }

  @observable expanded = false;

  @computed
  get staticText() {
    const { staticText } = this.props;
    return (
      staticText &&
      <Typography component='div'>
        <div> {staticText} </div>
      </Typography>
    );
  }

  @computed
  get list() {
    const { list = [] } = this.props;
    return list.length && (
      <Typography component='div'>
        {list.map((title, index) => (
          <div key={index}>&mdash; {title}</div>
        ))}
      </Typography>
    );
  }

  @computed
  get table() {
    const { table } = this.props;
    return table && table.rows.length && (
      <Table>
        {table.headers.length &&
          <TableHead>
            <TableRow>
              {table.headers.map((header, index) => (
                <TableCell key={index}>{header}</TableCell>
              ))}
            </TableRow>
          </TableHead>
        }
        <TableBody>
          {table.rows.map((row, index) => (
            <TableRow key={index}>
              {row.map((cell, index) => (
                <TableCell key={index}>{withDefault(cell)}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }

  @computed
  get title() {
    const { title: table } = this.props;
    if (typeof (table) === 'string') {
      return table;
    }
    else {
      return table && (
        <div>
          <Typography variant='subheading' >
            <div style={{ textAlign: "left" }}>{table && table.headers.length !== 0 ? table.headers[0] : ''}</div>
          </Typography>
          <Table>
            { table.rows && table.rows.length &&
              !this.expanded ?
                <TableBody>
                  {table.rows.map((row, index) => (
                    <TableRow key={index} sx={{ "& td": { border: 0 } }}>
                      {row.map((cell, index) => (
                        <TableCell key={index} style={{ borderBottom: "none" }}>
                          {withDefault(cell)}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
                : ""
            }
          </Table>
        </div>
      );
    }
  }

  @computed
  get content() {
    return this.staticText || this.list || this.table || this.props.children;
  }

  @computed
  get defaultExpanded() {
    const { expanded } = this.props;
    const { collapsedByDefault } = this.appStore;
    const empty = !this.content;

    return collapsedByDefault ? false : empty ? false : expanded;
  }

  componentDidMount() {
    if (this.defaultExpanded) {
      this.appStore.allCollapsed = false;
      this.expanded = true;
    }

    autorun(() => {
      if (this.appStore.allCollapsed) {
        this.expanded = false;
      }
    });

    // reaction(
    //   () => { return { collapsed: this.appStore.collapsedByDefault, content: this.content } },
    //   ({ collapsed, content }) => this.expanded = collapsed ? false : !!content
    // );

  }

  render() {
    const { noPadding, classes } = this.props;

    return (
      <ExpansionPanel
        expanded={this.expanded}
        defaultExpanded={this.defaultExpanded}
        onChange={this.handleOnChange}
      >
        <ExpansionPanelSummary expandIcon={<ChevronDown />} classes={{ focused: classes.clearFocus }}>
          <Typography variant='subheading' >{this.title}</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails
          className={classnames(
            [classes.scrollable],
            {
              [classes.noPadding]: noPadding || this.table
            }
          )}
        >
          {this.content || <Typography>Нет</Typography>}
        </ExpansionPanelDetails>
        {this.props.sourceLink &&
          <ExpansionPanelActions>
            <Button variant="raised" size="small" onClick={this.handleSourceClick} >Открыть источник</Button>
          </ExpansionPanelActions>
        }
      </ExpansionPanel>
    );
  }

  @action.bound
  handleOnChange(event, expanded) {
    this.expanded = expanded;
    if (expanded) {
      const { count, action } = this.props;
      if (count !== undefined && count === 0) {
        const { code } = this.appStore;
        switch (action) {
          case 'notes':
            this.appStore.dataStore.fetchCodeDataNotes(code);
            break;
          case 'comments':
            this.appStore.dataStore.fetchCodeDataComment(code);
            break;
          case 'classification_comments':
            this.appStore.dataStore.fetchCodeDataClassification_comments(code);
            break;
          default:
            break;
        }
      }
      this.appStore.allCollapsed = false;
      this.appStore.sendEvent(INFO_EVENT.EXPAND);
    }
    else {
      this.appStore.sendEvent(INFO_EVENT.COLLAPSE);
    }
  }

  @action.bound
  handleSourceClick() {
    const { sourceLink } = this.props;
    if (sourceLink) {
      window.open(sourceLink);
    }
  }

}

function withDefault(value, fallbackValue = '') {
  const shouldReturnValue = value !== null && value !== undefined;
  return shouldReturnValue ? value : fallbackValue;
}



// WEBPACK FOOTER //
// ./src/components/CodeInfoSection.js